import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { handleActions } from 'redux-actions';
import { fetchArtAuthorSuccess } from './actions';
import { reduxKey } from './constants';
const defaultState = {
    artAuthor: undefined
};
const handleFetchPopupArtAuthorSuccess = (state, { payload  })=>{
    const { user  } = payload;
    return _object_spread_props(_object_spread({}, state), {
        artAuthor: user
    });
};
const reducer = handleActions({
    [fetchArtAuthorSuccess.toString()]: handleFetchPopupArtAuthorSuccess
}, defaultState);
export default {
    [reduxKey]: reducer
};
